/**
 * Created by lvardarova on 29/04/16.
 */
import React from 'react';
import SvgIcon from '../../svgIcon/SvgIcon';

export function Pants(props) {
    return (
        <SvgIcon {...props}>
            <polygon points="8.43,2 0.575,2 0,12 3.205,12 4.5,5.91 5.875,12 9,12" />
        </SvgIcon>
    );
}

Pants.defaultProps = {
    viewBox: '0 0 9 16'
};

export default Pants;
